import { Component } from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";
import { Button } from "../ui/button";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Render error caught by ErrorBoundary:", error, info);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <div className="grid min-h-[60vh] place-items-center p-6" data-testid="app-error-boundary">
          <div className="max-w-md rounded-xl border border-red-200 bg-red-50 p-6 text-center">
            <AlertTriangle className="mx-auto mb-3 h-10 w-10 text-red-500" />
            <h2 className="mb-1 font-display text-lg font-semibold text-red-800">Something went wrong on this screen</h2>
            <p className="mb-4 text-sm text-red-700">
              The page hit an unexpected error. Your data is safe — try again or reload the app.
            </p>
            <div className="flex justify-center gap-2">
              <Button variant="outline" onClick={this.reset} data-testid="error-try-again">
                <RotateCcw className="mr-1.5 h-4 w-4" /> Try again
              </Button>
              <Button className="bg-red-600 hover:bg-red-700" onClick={() => window.location.reload()} data-testid="error-reload">
                Reload app
              </Button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
